export default "__VITE_ASSET__BO_jyc0___"